import React from 'react'
import RolesFunctionItem from "./RolesFunctionItem"

function RolesFunctionBody(props) {
    const {listRoles} = props

    return (
        <tbody className="TableBody">
        {
            !!listRoles && listRoles.length > 0 ? listRoles.map((item, index) => (
                <RolesFunctionItem key={index} index={index} item={item} {...props}/>
            )) : <tr className="NoRecord">
                <td colSpan={3}>Không có bản ghi nào</td>
            </tr>
        }
        </tbody>
    )
}

export default RolesFunctionBody
